import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryList = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchFormLibraryList = async ({ skip = 0, limit = 20 }) => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get(`${BASE_URL}v1/form-library/`, {
        params: { skip, limit },
      });
      setResponse(res.data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { response, error, isLoading, fetchFormLibraryList };
};

export default useFormLibraryList; 